<template>
  <div class="playlist" :style="'height: ' + playerHeight">
    <a 
      v-for="(video, index) in videos" 
      @click.prevent="selectVideo(index)" 
      :id="'video-' + video.id" 
      :key="index" 
      :class="{selected: isCurrent(index)}" 
      class="playlist-item" 
      href="#">
      <div class="grid-x">
        <div class="cell small-5 medium-4 large-4 poster-image-holder">
          <div v-if="video.poster_img.small">
            <div class="poster-image" :style="'background-image:url(' + video.poster_img.small + ')'"></div>
          </div>
          <div v-else>
            
          </div>
        </div>
        <div class="cell small-7 medium-8 large-8 details">
          <h5>{{video.title}}</h5>
          <p>{{video.description}}</p>
        </div>
      </div>
    </a>
  </div>
</template>

<script>

export default {
  name: 'Playlist',
  methods: {
    selectVideo(index) {
      if (index != this.currentIndex) {
        this.$store.commit('autoplay', true)
        this.$store.commit('selectVideo', index)
      }
    },
    isCurrent (index) {
      return (index == this.currentIndex)
    }
  },
  computed: {
    videos() {
      return this.$store.getters.playlist.videos
    },
    currentIndex () {
      return this.$store.getters.selected
    },
    playerHeight() {
      const obj = document.getElementById('player-' + this.$store.getters.appID)
      console.log('obj', obj)
      if (obj) {
        return obj.clientHeight + 'px'
      } else {
        return '0px'
      }
    }
  }
}
</script>
